<template>
  <van-pull-refresh v-model="isLoading" pulling-text="Tarik ke bawah untuk refresh..."
    loosing-text="Lepaskan untuk refresh..." success-text="Refresh Berhasil" loading-text=" " @refresh="onRefresh">
    <div class="content">

      <div class="jasa">
        <img src="@/assets/img/jasa.png" alt="">
        <img src="@/assets/img/afpi.png" alt="">
      </div>
      <div class="top">
        <div class="title_img">
          <h4 class="name">
            <span>Pasar pinjaman</span>
            <span v-if="isUseLatestLogic()" @click="visibleLogOut = true">Keluar</span>
          </h4>
          <div class="Semua_orabg_meminjam">
            <div>Semua orang meminjam</div>
            <span>Dapat mengajukan beberapa produk sekaligus</span>
          </div>
        </div>
        <img class="boy_bg" src="@/assets/img/boy_bg.png" alt="" />

        <div class="top_bg">
          <van-notice-bar color="#BAB9B8" background="#fff" :left-icon="trumpet" @click="visible = true">
            <span class="inform" v-for="(item, index) in this.form.msgList" :key="index">{{ item }}</span>
          </van-notice-bar>
          <div class="productBox">
            <img src="@/assets/img/product_icon.png" alt="" />
            <span>Modal Uang</span>
            <img class="home1_biaoshi" src="@/assets/img/home1_biaoshi.png" alt="" />
          </div>

          <div class="jine">
            <div class="title">
              {{
                this.form.loanStatus == 5
                  ? " Total Pembayaran"
                  : "Pinjaman Maksimum"
              }}
            </div>
            <span>Rp {{ formatNumberWithCommas(this.form.loanMoney) }}</span>
          </div>
          <!-- 状态1到9 -->
          <div class="jeikaun_xinxi" v-if="this.form.loanStatus != 5">
            <div class="li_lv">
              <div>Bunga Pinjaman</div>
              <span>{{ this.form.interestRate }}</span>
            </div>
            <div class="tian_shu">
              <div>Tenor Pinjaman</div>
              <span>{{ this.form.loanTerm }} Hari</span>
            </div>
            <div class="fengexian"></div>
          </div>
          <!-- 状态5 -->
          <div class="jeikaun_xinxi" v-else>
            <div class="li_lv">
              <div>Tanggal pembayaran</div>
              <span>{{ this.form.interestRate }}</span>
            </div>
            <div class="tian_shu">
              <div>Jumlah Hari Keterlambatan</div>
              <span>{{ this.form.loanTerm }} Hari</span>
            </div>
          </div>

          <!-- 状态1-9按钮 -->
          <div v-if="this.form.loanStatus != 5" class="pinjam_uang" @click="goHome">
            Ajukan Sekarang
          </div>
          <!-- 状态5按钮 -->
          <div v-else class="pinjam_uang pinjam_uang5" @click="goHome">
            Pembayaran
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="productCard" v-for="(item, index) in this.form.marketList" :key="index" @click="goOther(item)">
          <div class="iklan" v-if="item.iklan">
            {{ item.iklan }}
          </div>
          <div class="product">
            <img :src="item.product_logo" alt="" />
            <div class="productName">
              <div>{{ item.product_name }}</div>
              <span>{{ item.product_title }}</span>
            </div>

            <div :class="item.product_click == 1 ? 'text_btn' : 'text_btn_disenable'
              " :style="{
                background: item.product_status == 5 ? '#FF6B32' : '#ffbc32',
              }">
              {{ item.product_button }}
            </div>
          </div>
          <div class="juta" v-for="(productItem, productIndex) in item.product_list" :key="productIndex">
            <div v-for="(value, key) in productItem" :key="key">
              <span>{{ key }}:</span>
              <span>{{
                typeof value === "number"
                  ? formatNumberWithCommas(value)
                  : value
              }}</span>
            </div>
          </div>
          <van-notice-bar color="#999999" background="#fff" :left-icon="trumpet" @click="visible = true"
            v-if="item.msgList.length > 0">
            <span class="inform" v-for="(msgItem, msgIndex) in item.msgList" :key="msgIndex">{{ msgItem }}</span>
          </van-notice-bar>
        </div>
      </div>
      <div class="advertising" v-show="advertisingShow" @click="goAdvertising">
        <img src="@/assets/img/advertising_close.png" @click="advertisingShow = false" />
      </div>
      <van-dialog v-model="visible" :showConfirmButton="false">
        <div class="dialog">
          <p class="title">{{ this.form.msgList[0] }}</p>
          <p class="tip">
            {{ this.form.msgList[1] }}
          </p>
          <button type="button" class="btn" @click="visible = false">
            Setuju
          </button>
        </div>
      </van-dialog>
    </div>
    <van-dialog v-model="visibleLogOut" show-cancel-button cancel-button-text="Batal" confirm-button-text="Setuju"
      @cancel="visibleLogOut = false" @confirm="logOut">
      <h3 class="logout_text">yakin untuk keluar?</h3>
    </van-dialog>
    <van-dialog v-model="visibleHint" :showConfirmButton="false">
      <div class="hint_box">
        <img class="hint" src="@/assets/img/hint.png" alt="" />
        <img class="img_btn" src="@/assets/img/hint_btn.png" alt="" @click="visibleHint = false" />
      </div>
    </van-dialog>
  </van-pull-refresh>
</template>

<script>
import request from '@/utils/request'
import Vue from 'vue'
import { NoticeBar, Dialog, PullRefresh } from 'vant'
import dialogVisible from '@/mixins/dialogVisible'
import trumpet from '@/assets/img/trumpet.png'

import store from '@/store'
import Cookies from 'js-cookie'
import trafficConfig from '@/mixins/trafficConfig'

Vue.use(NoticeBar)
Vue.use(PullRefresh)

export default {
  name: 'Home1',
  mixins: [dialogVisible, trafficConfig],
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      trumpet: trumpet,
      isLoading: false,
      isRequest: false,
      advertisingShow: true,
      visibleLogOut: false,
      visibleHint: false,
      form: {
        marketList: [],
        msgList: [],
        product_list: []
      }
    }
  },
  created () {
    this.getState()
    const t = this
    // 添加 visibilitychange 事件监听器
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        // 页面变为可见时执行的逻辑
        t.getState()
      }
    })
  },
  methods: {
    // 下拉刷新
    onRefresh () {
      this.getState()
    },
    // 获取状态
    getState () {
      request.post('marketHomepage').then(res => {
        this.form = res
        this.form.marketList[0].product_list[0]['Jumlah Pinjaman'] = 'Rp8.000.000'
        this.form.marketList[0].msgList = []
        this.form.marketList[0].product_name = this.productName
        this.form.marketList[0].product_title = 'Pinjaman Online OJK'
        this.form.marketList[0].product_logo = this.home1_yinliu_logo
        this.form.marketList[0].iklan = 'iklan'
        this.form.marketList[0].product_click = 1
        this.form.marketList[0].appStore_url = this.downloadUrl
        this.isLoading = false
      })
    },
    // 去首页
    goHome () {
      if (this.form.switch === 2) {
        this.visibleHint = true
        return
      }
      if (this.form.switch === 1) {
        this.$router.push({
          path: '/home'
        })
      }
    },
    // 跳转到其他项目
    goOther (item) {
      if (this.isRequest) {
        return
      }
      if (item.appStore_url) {
        window.location = item.appStore_url
        return
      }
      this.isRequest = true
      if (item.switch === 2) {
        this.visibleHint = true
        this.isRequest = false
        return
      }
      const phone = item.jump_url.match(/phone=([^&]*)/)[1]
      // 给定的完整 URL 字符串
      const urlString = item.jump_url
      // 使用字符串截取方法获取不带参数的跳转地址
      let redirectUrl = urlString.split('?')[0]
      // 判断最后一位是否是 '/'
      if (redirectUrl.endsWith('/')) {
        // 去掉最后一位
        redirectUrl = redirectUrl.slice(0, -1)
      }
      // 获取登录信息  UC
      request.post('https://maapi.nyxlyn.cc/queryUserInfo', { phone }).then(res => {
        window.location = `${redirectUrl}/transfer?data=${JSON.stringify(res)}&SSO=1`
        // window.location = `http://localhost:8080/transfer?data=${JSON.stringify(res)}&SSO=1`
      }).finally(() => {
        setTimeout(() => {
          this.isRequest = false
        }, 300)
      })
    },
    // 退出登录
    logOut () {
      store.commit('recordInfo', {
        type: 'userInfo',
        value: {}
      })
      window.localStorage.removeItem('userInfo')
      Cookies.remove('userInfo')
      try {
        console.log('try')
        window.webkit.messageHandlers.logout.postMessage('')
      } catch (e) {
        console.log('catch')
        this.$router.push('/login')
      }
    },
    // BRD
    goAdvertising () {
      window.location = this.brdDownloadUrl
    }
  }
}
</script>
<style scoped lang="less">
.content {
  position: relative;
  background: #f7f8ff;
  min-height: 100vh;

  .jasa {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    img {
      height: 45px;
    }
  }

  .advertising {
    height: 90px;
    width: 100%;
    position: fixed;
    bottom: 0;
    background: url("~@/assets/img/advertising_bg.png") no-repeat;
    background-size: 100% 100%;

    img {
      position: absolute;
      width: 28px;
    }
  }
}

.top {
  background: url("~@/assets/img/home1_bg.png") no-repeat;
  background-size: 100% 100%;
  height: 760px;

  .title_img {
    padding-left: 28px;

    .name {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 40px;
      padding-bottom: 25px;
      padding-right: 28px;
      margin-bottom: 50px;

      span {
        font-weight: 600;
        font-size: 34px;
        color: #ffffff;
      }

      span:nth-child(2) {
        position: absolute;
        right: 28px;
      }
    }

    .Semua_orabg_meminjam {
      position: relative;
      padding-bottom: 113px;
      font-size: 0;
      padding-left: 20px;

      div {
        font-weight: 900;
        font-size: 36px;
        color: #ffffff;
        margin-bottom: 1px;
      }

      span {
        font-weight: 400;
        font-size: 22px;
        color: #ffffff;
      }

      img {
        position: absolute;
        right: 60px;
        bottom: -16px;
        width: 142px;
        z-index: 9;
      }
    }
  }

  .boy_bg {
    position: absolute;
    right: 0;
    top: 100px;
    width: 215px;
  }

  .top_bg {
    position: relative;
    width: 690px;
    height: 700px;
    background: url("~@/assets/img/top_bg.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 28px;
    margin: 0 auto;
    padding-bottom: 45px;

    /deep/ .van-icon__image {
      width: 27px;
      height: 26px;
      margin-right: 10px;
    }

    /deep/ .van-notice-bar {
      position: absolute;
      top: -36px;
      left: 0;
      right: 0;
      border-radius: 27px;
      margin: 0 auto;
      height: 54px;
      width: 598px;
    }

    .productBox {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 12px;
      padding-top: 50px;

      img {
        width: 111px;
        margin-bottom: 12px;
        border-radius: 50%;
        border: 8px solid #fda324;
      }

      span {
        font-weight: 600;
        font-size: 28px;
        color: #333;
      }

      .home1_biaoshi {
        position: absolute;
        right: 20px;
        top: 30px;
        width: 80px;
        border: none;
      }
    }

    .jine {
      text-align: center;
      font-size: 0;
      padding: 20px 0;
      padding-bottom: 70px;

      span {
        font-weight: 900;
        font-size: 51px;
        color: #333;
      }

      .title {
        font-size: 26px;
        color: #666666;
      }
    }

    .jeikaun_xinxi {
      position: relative;
      display: flex;
      justify-content: space-evenly;
      margin-top: 40px;
      margin-bottom: 40px;
      font-size: 26px;

      .li_lv,
      .tian_shu {
        flex: 1;
        text-align: center;

        div {
          font-weight: 600;
          font-size: 24px;
          color: #666666;
          margin-bottom: 10px;
        }

        span {
          font-weight: 600;
          font-size: 30px;
          color: #000000;
        }
      }

      .fengexian {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50% -50%);
        background: #d8d6d6;
        width: 2px;
        height: 30px;
      }
    }

    .pinjam_uang {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 900;
      font-size: 34px;
      color: #ffffff;
      margin: 0 auto;

      width: 487px;
      height: 108px;
      background: #3e5dfb;
      border-radius: 54px;
    }

    .pinjam_uang5 {
      background: #ff5400;
    }
  }
}

.bottom {
  padding: 78px 32px;
  margin-top: 0;
  margin-top: 300px;

  .productCard {
    position: relative;
    margin-bottom: 24px;
    width: 634px;
    background: #ffffff;
    border-radius: 28px;
    border: 1px solid #e3e3e3;
    padding: 20px;

    .iklan {
      position: absolute;
      right: 0;
      top: 0;
      background: #aaaaaa;
      font-size: 24px;
      color: #ffbc09;
      padding: 2px 10px;
      border-radius: 6px;
    }

    /deep/ .van-icon__image {
      width: 27px;
      height: 26px;
      margin-right: 10px;
    }

    /deep/ .van-notice-bar {
      height: 69px;
      border-radius: 28px;
      border: 1px solid #f2ecec;
      margin-bottom: 23px;
    }

    .product {
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 95px;
        height: 95px;
        margin-right: 10px;
      }

      .productName {
        font-size: 22px;

        div {
          font-weight: 600;
          font-size: 30px;
          color: #333333;
          margin-bottom: 8px;
        }

        span {
          font-weight: 400;
          font-size: 22px;
          color: #666666;
        }

      }

      .text_btn {
        margin-left: auto;
        width: 238px;
        height: 65px;
        border-radius: 65px;
        font-weight: 600;
        font-size: 24px;
        line-height: 65px;
        text-align: center;
        color: #fff;
      }

      .text_btn_disenable {
        .text_btn;
        background: #9b9eae !important;
      }

    }
  }

  .juta {
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      height: 76px;
      padding: 0 20px;
      font-weight: 400;
      font-size: 26px;
      color: #666666;
      border-bottom: 1px solid #f2ecec;

      span:nth-child(2) {
        font-weight: 600;
        font-size: 26px;
        color: #333333;
      }
    }

    div:nth-child(1) {
      margin-top: 21px;
    }

    div:last-child {
      border: none;
    }
  }

  .describe {
    padding: 20px;
    padding-top: 10px;
    background: #f8f8f8;
    font-weight: 400;
    font-size: 26px;
    color: #999999;
    line-height: 37px;
    margin-bottom: 30px;
  }
}

.dialog {
  padding: 40px 30px;

  .title {
    font-size: 50px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .tip {
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 70px;
  }

  .btn {
    width: 100%;
    height: 100px;
    border-radius: 15px;
    font-size: 40px;
    font-weight: 600;
    color: #fff;
    background: #3a3a3a;
  }
}

.logout_text {
  color: #000;
  font-size: 46px;
  margin: 60px 0px;
  text-align: center;
}

.hint_box {
  position: relative;

  .hint {
    width: 100%;
  }

  .img_btn {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 500px;
  }
}
</style>
